import apiType from "../APIResponseActions/type";
import {
  AuthAPI,
  UploadFormData,
  BufferAuthAPI,
  UnAuthUploadFormData,
} from "../../../Auth/requestHandler";
import {
  convertPropertyTimeToUtc,
  convertDateTimeToUtc,
} from "../../Components/helper";
import t from "./types";
import moment from "moment";

export const scanPlate1 = (imageURL) => async (dispatch) => {
  try {
    const url =
      "https://api.openalpr.com/v3/recognize_bytes?recognize_vehicle=1&country=us&secret_key=sk_7f2760734b3fed475c07a412";
    const API_details = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: imageURL,
    };
    const response = await fetch(url, API_details);

    if (response.ok) {
      const responseData = await response.json();

      await dispatch({
        type: t.FETCH_PALTE_SCANNED_DATA,
        payload: responseData,
      });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: "Plate scanned successfully",
      });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const scanPlate = (formData) => async (dispatch) => {
  console.log("form data for scan plate:----", formData.get("stall_id"));
  try {
    const scan_time = timestamp();
    const url = "lpr/scan_plate/" + scan_time;
    const result = await UploadFormData("domain", url, "POST", formData);
    console.log("scnaplate1111", result);
    if (result && result.success) {
      console.log("=====ifffff===");
      const tickets =
        result.extra &&
        Object.keys(result.extra).length &&
        result.extra.tickets &&
        result.extra.tickets.length
          ? result.extra.tickets
          : [];
      await dispatch({
        type: t.FETCH_PALTE_VALIDITY,
        payload: {
          data: result.data,
          scan_time: scan_time,
          isPlateApproved: true,
          tickets: tickets,
          lpn: result?.extra?.report_data?.lpn,
          end: result?.extra?.report_data?.end,
        },
      });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: result.message,
      });
    } else {
      await dispatch({
        type: t.FETCH_PALTE_VALIDITY,
        payload: {
          data: result?.extra?.report_data,
          scan_time: scan_time,
          lpn: result?.extra?.report_data?.lpn,
          isPlateApproved: result?.extra?.report_data?.result === "Approved",
          tickets: result.extra.tickets,
        },
      });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: result.message,
      });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const manuallyPlateCheck = (plateData) => async (dispatch) => {
  try {
    const { lpn, selectedLot, selectedStall } = plateData;
    let selectedStall1;
    if (!selectedStall) {
      selectedStall1 = null;
    } else {
      selectedStall1 = selectedStall;
    }
    const scan_time = timestamp();
    const url =
      "lpr/check/" +
      lpn +
      "/" +
      scan_time +
      "/" +
      selectedLot +
      "/" +
      selectedStall1;
    const result = await AuthAPI("domain", url, "GET");
    if (result && result.success) {
      const tickets =
        result.extra &&
        Object.keys(result.extra).length &&
        result.extra.tickets &&
        result.extra.tickets.length
          ? result.extra.tickets
          : [];
      await dispatch({
        type: t.FETCH_PALTE_VALIDITY,
        payload: {
          data: result.data,
          scan_time: scan_time,
          isPlateApproved: true,
          tickets: tickets,
          end: result?.extra?.report_data?.end,
        },
      });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: result.message,
      });
    } else {
      // const data =
      //   result.data && Object.keys(result.data).length ? result.data : null;
      // let passagePassData;
      // let isPassagePassData = false;
      // if ("passagePassData" in result) {
      //   passagePassData = result.passagePassData
      //     ? result.passagePassData[0]
      //     : [];
      //   isPassagePassData = true;
      // }
      // const isPlateApproved = !!(
      //   passagePassData && passagePassData.result === "allowed"
      // );
      // console.log("========", passagePassData);
      await dispatch({
        type: t.FETCH_PALTE_VALIDITY,
        payload: {
          data: result?.extra?.report_data,
          scan_time: scan_time,
          isPlateApproved: result?.extra?.report_data?.result === "Approved",
          tickets: result.extra.tickets,
        },
      });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

function timestamp() {
  function pad(n) {
    return n < 10 ? "0" + n : n;
  }
  const d = new Date();
  const dash = "-";
  const colon = ":";
  return (
    d.getFullYear() +
    dash +
    pad(d.getMonth() + 1) +
    dash +
    pad(d.getDate()) +
    "T" +
    pad(d.getHours()) +
    colon +
    pad(d.getMinutes()) +
    colon +
    pad(d.getSeconds())
  );
}

export const sendEmail = (formData) => async (dispatch) => {
  try {
    const url = "permit/email";
    const response = await UploadFormData("domain", url, "POST", formData);
    if (response && response.data) {
      await dispatch({ type: t.UPDATE_TERNINAl, payload: response.data });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: response.msg,
      });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const getAuditReoprts = (typeValue) => async (dispatch) => {
  try {
    const url = "lpr/audit_report?type=" + typeValue;
    const response = await AuthAPI("domain", url, "GET");
    if (response && response.length) {
      await dispatch({ type: t.GET_AUDIT_REPORT, payload: response });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: response.msg,
      });
    }
    dispatch({
      type: t.SHOW_HIDE_LOADER,
      payload: false,
    });
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const get_user_lots = () => async (dispatch) => {
  try {
    const url = "user/list";
    const response = await AuthAPI("domain", url, "GET");
    console.log("get_user_lots:::::=======", response);
    await dispatch({ type: t.GETUSERLOTS, payload: response.lots });
    await dispatch({ type: t.GETALLUSERS, payload: response.users });
    await dispatch({
      type: apiType.API_RESPONSE_SUCCESS,
      payload: "fetch successfully",
    });
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: "failed to fetch",
    });
  }
};

export const get_user_type = () => async (dispatch) => {
  try {
    const url = "user/type";
    const response = await AuthAPI("domain", url, "GET");

    await dispatch({ type: t.GETUSERTYPES, payload: response.users });
    await dispatch({
      type: apiType.API_RESPONSE_SUCCESS,
      payload: "fetch successfully",
    });
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: "failed to fetch",
    });
  }
};

export const getCitationList = (pageObj) => async (dispatch) => {
  try {
    const body = {
      selectedOption: pageObj.selectedOption,
      page_size: pageObj.Norow,
      page: pageObj.page,
      order_by: pageObj.selectedColumn,
      sorting: pageObj.sort_direction,
      PropertyId: pageObj.PropertyId,
      lot_id: pageObj.lot_id,
      unit_id: pageObj.unit_id,
      childcheckbox: pageObj.childcheckbox,
      // month: pageObj.month,
      year: pageObj.year,
      // currentDate: pageObj.currentDate,
      // startDate: pageObj.startDate,
      // endDate: pageObj.endDate,
      selectedRadio: pageObj.selectedRadio,
      timezone: pageObj.timezone,
    };

    if (pageObj.month) {
      const timeFormat = moment(pageObj.month).format("YYYY-MM-DD HH:mm:SS");
      const convertedTime = moment.tz(timeFormat, pageObj.timezone).format();
      const timeInUTCStart = moment.tz(convertedTime, "UTC").format();
      body.month = timeInUTCStart;
    }

    if (pageObj.currentDate) {
      const timeFormat = moment(pageObj.currentDate).format("YYYY-MM-DD");
      const startTimeFormat = `${timeFormat} 00:00:00`;
      const convertedTime = moment
        .tz(startTimeFormat, pageObj.timezone)
        .format();
      const timeInUTCStart = moment.tz(convertedTime, "UTC").format();

      const EndTimeFormat = `${timeFormat} 23:59:59`;
      const convertedEndTime = moment
        .tz(EndTimeFormat, pageObj.timezone)
        .format();
      const timeInUTCEnd = moment.tz(convertedEndTime, "UTC").format();

      body.currentDateStartTime = timeInUTCStart;
      body.currentDateEndTime = timeInUTCEnd;
    }

    if (pageObj.startDate && pageObj.endDate) {
      const timeFormat = moment(pageObj.startDate).format("YYYY-MM-DD");
      const startTimeFormat = `${timeFormat} 00:00:00`;
      const convertedTime = moment
        .tz(startTimeFormat, pageObj.timezone)
        .format();
      const timeInUTCStart = moment.tz(convertedTime, "UTC").format();

      const timeEndFormat = moment(pageObj.endDate).format("YYYY-MM-DD");
      const EndTimeFormat = `${timeEndFormat} 23:59:59`;
      const convertedEndTime = moment
        .tz(EndTimeFormat, pageObj.timezone)
        .format();
      const timeInUTCEnd = moment.tz(convertedEndTime, "UTC").format();

      body.startDate = timeInUTCStart;
      body.endDate = timeInUTCEnd;
    }

    const url = "ticket/citation-issued";
    const response = await AuthAPI("domain", url, "POST", body);
    if (response && response.success) {
      await dispatch({
        type: t.FETCH_CITATION_REPORT_LIST,
        payload: response,
      });
    } else {
      await dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: response.message,
      });
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const getCitationIssuedSummary = (pageObj) => async (dispatch) => {
  try {
    const {
      timezone,
      // Norow,
      PropertyId,
      weekstartDate,
      weekEndDate,
      summaryMonth,
      currentSummaryDate,
      lot_id,
      year,
      selectedRadio,
      childcheckbox,
    } = pageObj;
    const body = {
      // page_size: Norow,
      // page: pageObj.page,
      PropertyId: PropertyId,
      timezone: timezone,
      exportValue: pageObj.exportData ? pageObj.exportData : false,
    };
    if (childcheckbox) {
      body.childcheckbox = pageObj.childcheckbox;
    }
    if (summaryMonth) {
      const timeFormat = moment(summaryMonth).format("YYYY-MM-DD HH:mm:SS");
      const convertedTime = moment.tz(timeFormat, timezone).format();
      const timeInUTCStart = moment.tz(convertedTime, "UTC").format();
      body.summaryMonth = timeInUTCStart;
    }
    if (currentSummaryDate) {
      const { startDateInUtc, endDateInUtc } = convertPropertyTimeToUtc(
        timezone,
        currentSummaryDate,
        currentSummaryDate,
        false
      );
      body.currentSummaryStartTime = startDateInUtc;
      body.currentSummaryEndTime = endDateInUtc;
    }
    if (weekstartDate && weekEndDate) {
      const { startDateInUtc, endDateInUtc } = convertPropertyTimeToUtc(
        timezone,
        weekstartDate,
        weekEndDate,
        false
      );
      body.weekstartDate = startDateInUtc;
      body.weekEndDate = endDateInUtc;
    }

    if (lot_id) {
      body.lot_id = lot_id;
    }
    if (year) {
      body.year = year;
    }
    if (selectedRadio) {
      body.selectedRadio = selectedRadio;
      let day = "";
      if (selectedRadio === "today" || selectedRadio === "yesterday") {
        if (selectedRadio === "today") {
          day = new Date();
        } else {
          day = moment(new Date()).add(-1, "days").format("YYYY-MM-DD");
        }
        const { startDateInUtc, endDateInUtc } = convertPropertyTimeToUtc(
          timezone,
          day,
          day,
          false
        );
        body.todayStartTime = startDateInUtc;
        body.todayEndTime = endDateInUtc;
      }
    }

    if (childcheckbox) {
      body.childcheckbox = childcheckbox;
    }

    const url = "ticket/citation-issued-summary";
    if (body.exportValue) {
      try {
        return await BufferAuthAPI("domain", url, "POST", body);
      } catch (error) {
        await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
      }
    } else {
      const response = await AuthAPI("domain", url, "POST", body);
      if (response && response.success) {
        await dispatch({
          type: t.FETCH_CITATION_ISSUED_SUMMARY,
          payload: response,
        });
      } else {
        await dispatch({
          type: apiType.API_RESPONSE_FAILURE,
          payload: response.message,
        });
      }
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const getCitationIssuedByEnforcerSummary =
  (pageObj) => async (dispatch) => {
    try {
      const {
        timezone,
        PropertyId,
        weekstartDate,
        weekEndDate,
        currentSummaryDate,
        childcheckbox,
      } = pageObj;
      const body = {
        PropertyId: PropertyId,
        timezone: timezone,
        exportValue: pageObj.exportData ? pageObj.exportData : false,
      };
      if (childcheckbox) {
        body.childcheckbox = pageObj.childcheckbox;
      }
      if (currentSummaryDate) {
        const { startDateInUtc, endDateInUtc } = convertPropertyTimeToUtc(
          timezone,
          currentSummaryDate,
          currentSummaryDate,
          false
        );
        body.currentSummaryStartTime = startDateInUtc;
        body.currentSummaryEndTime = endDateInUtc;
      }
      if (weekstartDate && weekEndDate) {
        const { startDateInUtc, endDateInUtc } = convertPropertyTimeToUtc(
          timezone,
          weekstartDate,
          weekEndDate,
          false
        );
        body.weekstartDate = startDateInUtc;
        body.weekEndDate = endDateInUtc;
      }

      if (childcheckbox) {
        body.childcheckbox = childcheckbox;
      }

      const url = "ticket/citation-issued-enforcer-summary";
      if (body.exportValue) {
        try {
          return await BufferAuthAPI("domain", url, "POST", body);
        } catch (error) {
          await dispatch({
            type: apiType.API_RESPONSE_FAILURE,
            payload: error,
          });
        }
      } else {
        const response = await AuthAPI("domain", url, "POST", body);
        if (response && response.success) {
          await dispatch({
            type: t.FETCH_CITATION_ISSUED_SUMMARY,
            payload: response,
          });
        } else {
          await dispatch({
            type: apiType.API_RESPONSE_FAILURE,
            payload: response.message,
          });
        }
      }
    } catch (error) {
      await dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: error.toString(),
      });
    }
  };

export const getCitationPaidSummary = (pageObj) => async (dispatch) => {
  try {
    const { timezone, currentSummaryDate, weekstartDate, weekEndDate } =
      pageObj;
    const body = {
      // page_size: pageObj.Norow,
      // page: pageObj.page,
      timezone: timezone,
      PropertyId: pageObj.PropertyId,
      exportValue: pageObj.exportData ? pageObj.exportData : false,
    };
    if (pageObj.childcheckbox) {
      body.childcheckbox = pageObj.childcheckbox;
    }
    if (currentSummaryDate) {
      const { startDateInUtc, endDateInUtc } = convertPropertyTimeToUtc(
        timezone,
        currentSummaryDate,
        currentSummaryDate,
        false
      );
      body.currentSummaryStartTime = startDateInUtc;
      body.currentSummaryEndTime = endDateInUtc;
    }
    if (weekstartDate && weekEndDate) {
      const { startDateInUtc, endDateInUtc } = convertPropertyTimeToUtc(
        timezone,
        weekstartDate,
        weekEndDate,
        false
      );
      body.weekstartDate = startDateInUtc;
      body.weekEndDate = endDateInUtc;
    }
    const url = "ticket/citation-paid-summary";
    if (body.exportValue) {
      try {
        return await BufferAuthAPI("domain", url, "POST", body);
      } catch (error) {
        await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
      }
    } else {
      const response = await AuthAPI("domain", url, "POST", body);
      if (response && response.success) {
        await dispatch({
          type: t.FETCH_CITATION_PAID_SUMMARY,
          payload: response,
        });
      } else {
        await dispatch({
          type: apiType.API_RESPONSE_FAILURE,
          payload: response.message,
        });
      }
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const getCitationPaidPaymentSummary = (pageObj) => async (dispatch) => {
  try {
    const { timezone, currentSummaryDate, weekstartDate, weekEndDate } =
      pageObj;
    const body = {
      // page_size: pageObj.Norow,
      // page: pageObj.page,
      timezone: timezone,
      PropertyId: pageObj.PropertyId,
      exportValue: pageObj.exportData ? pageObj.exportData : false,
    };
    if (pageObj.childcheckbox) {
      body.childcheckbox = pageObj.childcheckbox;
    }
    if (currentSummaryDate) {
      const { startDateInUtc, endDateInUtc } = convertPropertyTimeToUtc(
        timezone,
        currentSummaryDate,
        currentSummaryDate,
        false
      );
      body.currentSummaryStartTime = startDateInUtc;
      body.currentSummaryEndTime = endDateInUtc;
    }
    if (weekstartDate && weekEndDate) {
      const { startDateInUtc, endDateInUtc } = convertPropertyTimeToUtc(
        timezone,
        weekstartDate,
        weekEndDate,
        false
      );
      body.weekstartDate = startDateInUtc;
      body.weekEndDate = endDateInUtc;
    }
    const url = "ticket/citation-paid-payment-summary";
    if (body.exportValue) {
      try {
        return await BufferAuthAPI("domain", url, "POST", body);
      } catch (error) {
        await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
      }
    } else {
      const response = await AuthAPI("domain", url, "POST", body);
      if (response && response.success) {
        await dispatch({
          type: t.FETCH_CITATION_PAID_SUMMARY,
          payload: response,
        });
      } else {
        await dispatch({
          type: apiType.API_RESPONSE_FAILURE,
          payload: response.message,
        });
      }
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const getRevenueList = (pageObj) => async (dispatch) => {
  try {
    const body = {
      selectedOption: pageObj.selectedOption,
      page_size: pageObj.Norow,
      page: pageObj.page,
      order_by: pageObj.selectedColumn,
      sorting: pageObj.sort_direction,
      PropertyId: pageObj.PropertyId,
      lot_id: pageObj.lot_id,
      unit_id: pageObj.unit_id,
      childcheckbox: pageObj.childcheckbox,
      exportLink: pageObj.exportLink,
      pdfLink: pageObj.pdfLink,
      //  month: pageObj.month,
      year: pageObj.year,
      // currentDate: pageObj.currentDate,
      // startDate: pageObj.startDate,
      // endDate: pageObj.endDate,
      selectedRadio: pageObj.selectedRadio,
      timezone: pageObj.timezone,
    };

    if (pageObj.month) {
      const timeFormat = moment(pageObj.month).format("YYYY-MM-DD HH:mm:SS");
      const convertedTime = moment.tz(timeFormat, pageObj.timezone).format();
      const timeInUTCStart = moment.tz(convertedTime, "UTC").format();
      body.month = timeInUTCStart;
    }

    if (pageObj.currentDate) {
      console.log("selecte date", pageObj.currentDate);
      const formatStartDate = moment(pageObj.currentDate).format("YYYY-MM-DD");
      const startDateWithTime = `${formatStartDate} 00:00:00`;
      const formatEndDate = moment(pageObj.currentDate).format("YYYY-MM-DD");
      const endDateWithTime = `${formatEndDate} 23:59:59`;
      console.log("passdatainconvertUtc", startDateWithTime, endDateWithTime);
      const { startcurrent_time, endcurrent_time } = convertDateTimeToUtc(
        pageObj.timezone,
        startDateWithTime,
        endDateWithTime
      );
      console.log("pass data in APi", startcurrent_time, endcurrent_time);
      body.currentDateStartTime = startcurrent_time;
      body.currentDateEndTime = endcurrent_time;
    }

    if (pageObj.startDate && pageObj.endDate) {
      const timeFormat = moment(pageObj.startDate).format("YYYY-MM-DD");
      const startTimeFormat = `${timeFormat} 00:00:00`;

      const timeEndFormat = moment(pageObj.endDate).format("YYYY-MM-DD");
      const EndTimeFormat = `${timeEndFormat} 23:59:59`;

      const { startcurrent_time, endcurrent_time } = convertDateTimeToUtc(
        pageObj.timezone,
        startTimeFormat,
        EndTimeFormat
      );
      body.startDate = startcurrent_time;
      body.endDate = endcurrent_time;
    }
    const url = "report/list";

    if (pageObj.exportLink || pageObj.pdfLink) {
      try {
        return await BufferAuthAPI("domain", url, "POST", body);
      } catch (error) {
        await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
      }
    } else {
      const response = await AuthAPI("domain", url, "POST", body);
      if (response && response.success) {
        await dispatch({
          type: t.FETCH_REVENUE_REPORT_LIST,
          payload: response,
        });
      } else {
        await dispatch({
          type: apiType.API_RESPONSE_FAILURE,
          payload: response.message,
        });
      }
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const getRevenueSummary = (pageObj) => async (dispatch) => {
  try {
    const body = {
      selectedOption: pageObj.selectedOption,
      // page_size: pageObj.Norow,
      // page: pageObj.page,
      //  order_by: pageObj.selectedColumn,
      // sorting: pageObj.sort_direction,
      PropertyId: pageObj.PropertyId,
      lot_id: pageObj.lot_id,
      unit_id: pageObj.unit_id,
      // childcheckbox: pageObj.childcheckbox,
      exportLink: pageObj.exportLink,
      pdfLink: pageObj.pdfLink,
      //  detailedDate: pageObj.detailedDate,
      //  month: pageObj.month,
      year: pageObj.year,
      // currentDate: pageObj.currentDate,
      // startDate: pageObj.startDate,
      // endDate: pageObj.endDate,
      selectedRadio: pageObj.selectedRadio,
      timezone: pageObj.timezone,
      exportValue: pageObj.exportData ? pageObj.exportData : false,
    };

    if (pageObj.childcheckbox) {
      body.childcheckbox = pageObj.childcheckbox;
    }

    if (pageObj.month) {
      const timeFormat = moment(pageObj.month).format("YYYY-MM-DD HH:mm:SS");
      const convertedTime = moment.tz(timeFormat, pageObj.timezone).format();
      const timeInUTCStart = moment.tz(convertedTime, "UTC").format();
      body.month = timeInUTCStart;
    }

    if (pageObj.detailedDate) {
      const timeFormat = moment(pageObj.detailedDate).format(
        "YYYY-MM-DD HH:mm:SS"
      );
      const convertedTime = moment.tz(timeFormat, pageObj.timezone).format();
      const timeInUTCStart = moment.tz(convertedTime, "UTC").format();
      body.detailedDate = timeInUTCStart;
    }

    if (pageObj.currentDate) {
      const formatStartDate = moment(pageObj.currentDate).format("YYYY-MM-DD");
      const startDateWithTime = `${formatStartDate} 00:00:00`;
      const formatEndDate = moment(pageObj.currentDate).format("YYYY-MM-DD");
      const endDateWithTime = `${formatEndDate} 23:59:59`;

      const { startcurrent_time, endcurrent_time } = convertDateTimeToUtc(
        pageObj.timezone,
        startDateWithTime,
        endDateWithTime
      );
      body.currentDateStartTime = startcurrent_time;
      body.currentDateEndTime = endcurrent_time;
    }

    if (pageObj.startDate && pageObj.endDate) {
      const timeFormat = moment(pageObj.startDate).format("YYYY-MM-DD");
      const startTimeFormat = `${timeFormat} 00:00:00`;

      const timeEndFormat = moment(pageObj.endDate).format("YYYY-MM-DD");
      const EndTimeFormat = `${timeEndFormat} 23:59:59`;

      const { startcurrent_time, endcurrent_time } = convertDateTimeToUtc(
        pageObj.timezone,
        startTimeFormat,
        EndTimeFormat
      );
      body.startDate = startcurrent_time;
      body.endDate = endcurrent_time;
    }
    const url = "report/summary/list";
    if (body.exportValue) {
      try {
        return await BufferAuthAPI("domain", url, "POST", body);
      } catch (error) {
        await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
      }
    } else {
      const response = await AuthAPI("domain", url, "POST", body);
      if (response && response.success) {
        await dispatch({
          type: t.FETCH_REVENUE_REPORT_SUMMARY_LIST,
          payload: response,
        });
      } else {
        await dispatch({
          type: apiType.API_RESPONSE_FAILURE,
          payload: response.message,
        });
      }
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const scanPlateForGoogleGlass = (formData) => async (dispatch) => {
  console.log("form data for scan plate:----", formData.get("stall_id"));
  try {
    const scan_time = timestamp();
    const url = "public/lpr/scan-glass/" + scan_time;
    const result = await UnAuthUploadFormData(url, "POST", formData);
    console.log("gooooooooscnaplate1111", result);
    if (result && result.success) {
      console.log("=====ifffff===");
      const tickets =
        result.extra &&
        Object.keys(result.extra).length &&
        result.extra.tickets &&
        result.extra.tickets.length
          ? result.extra.tickets
          : [];
      await dispatch({
        type: t.FETCH_PALTE_VALIDITY,
        payload: {
          data: result.data,
          scan_time: scan_time,
          isPlateApproved: true,
          tickets: tickets,
          lpn: result?.extra?.report_data?.lpn,
          end: result?.extra?.report_data?.end,
        },
      });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: result.message,
      });
    } else {
      await dispatch({
        type: t.FETCH_PALTE_VALIDITY,
        payload: {
          data: result?.extra?.report_data,
          scan_time: scan_time,
          lpn: result?.extra?.report_data?.lpn,
          isPlateApproved: result?.extra?.report_data?.result === "Approved",
          tickets: result.extra.tickets,
        },
      });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: result.message,
      });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};
